module.exports = __webpack_public_path__ + "img/collection-weddingRingsTensionRings@2x.4e959b0.jpg";